import BaseView from '../../../core/baseView';
import { reload } from '../../../validation/validation-controller';

export default BaseView.extend({
    initialize: function () {
        reload();
    }
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/pages/myAccount/profile/PersonalInformationView.js
 **/